/* Native details remain functional without JavaScript. Bind once across theme-editor reloads. */
(() => {
  if (window.welchNavigationBound) return;
  window.welchNavigationBound = true;
  document.addEventListener('toggle', (event) => {
    const item = event.target;
    if (!(item instanceof HTMLDetailsElement) || !item.matches('.w-nav__group') || !item.open) return;
    item.closest('[data-welch-nav]')?.querySelectorAll('details[open]').forEach((other) => {
      if (other !== item) other.open = false;
    });
  }, true);
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.w-nav__group[open]').forEach((item) => {
      const heldFocus = item.contains(document.activeElement);
      item.open = false;
      if (heldFocus) item.querySelector('summary')?.focus();
    });
  });
  document.addEventListener('click', (event) => {
    document.querySelectorAll('.w-nav__group[open]').forEach((item) => {
      if (!item.contains(event.target)) item.open = false;
    });
  });
})();
